/**
 * Format marketplace item price for display (EGP).
 * Numeric value is unchanged vs legacy "points" field — UI labeling only.
 */
export function formatItemPriceEgp(value) {
  const n = parseFloat(value);
  if (!Number.isFinite(n)) return '0 EGP';
  if (n === 0) return 'Free';
  const rounded = Math.round(n * 100) / 100;
  const str =
    rounded % 1 === 0
      ? String(Math.round(rounded))
      : rounded.toFixed(2).replace(/\.?0+$/, '');
  return `${str} EGP`;
}

/** Wallet / account balance — zero displays as "0 EGP", not "Free". */
export function formatWalletBalanceEgp(value) {
  const n = parseFloat(value);
  if (!Number.isFinite(n)) return '0 EGP';
  const rounded = Math.round(n * 100) / 100;
  const str =
    rounded % 1 === 0
      ? String(Math.round(rounded))
      : rounded.toFixed(2).replace(/\.?0+$/, '');
  return `${str} EGP`;
}

export function isFreeListing(itemOrPrice) {
  const price =
    itemOrPrice && typeof itemOrPrice === 'object'
      ? itemOrPrice.price
      : itemOrPrice;
  const numericPrice = parseFloat(price);
  return Number.isFinite(numericPrice) && numericPrice === 0;
}

/** Display label for a listing card/detail price. */
export function formatListingPriceLabel(item) {
  if (isFreeListing(item)) return 'Free';
  return formatItemPriceEgp(item?.price);
}
